/**
 * Consent banner (§8.1): genuine granular choice on first visit. Necessary is
 * always on; analytics and marketing start OFF. Until the player actively
 * consents, no event of any kind leaves for Meta/Google/Mailchimp — the
 * server enforces that; this banner records the decision.
 */

import { api } from './api.js';

export function showConsentBanner(onDecided: () => void): void {
  const el = document.createElement('div');
  el.className = 'hnp-consent';
  el.innerHTML = `
    <div class="hnp-consent__card" role="dialog" aria-label="Privacy choices">
      <p class="hnp-consent__title">Your privacy choices</p>
      <p class="hnp-consent__text">We use strictly necessary storage to run the games and prevent abuse.
      Anything else is up to you — nothing optional is on unless you turn it on.</p>
      <label class="hnp-consent__row"><input type="checkbox" checked disabled> Necessary <span>always on — session, security, abuse control</span></label>
      <label class="hnp-consent__row"><input type="checkbox" id="c-analytics"> Analytics <span>helps us see which games people enjoy</span></label>
      <label class="hnp-consent__row"><input type="checkbox" id="c-marketing"> Marketing <span>personalised offers from Health Needs</span></label>
      <div class="hnp-consent__actions">
        <button type="button" class="hnp-consent__decline" id="c-decline">Decline non-essential</button>
        <button type="button" class="cta" id="c-save">Save my choices</button>
      </div>
    </div>`;
  document.body.appendChild(el);

  const finish = async (analytics: boolean, marketing: boolean): Promise<void> => {
    try {
      await api.consent(analytics, marketing);
    } finally {
      el.remove();
      onDecided();
    }
  };
  (el.querySelector('#c-decline') as HTMLButtonElement).addEventListener('click', () => void finish(false, false));
  (el.querySelector('#c-save') as HTMLButtonElement).addEventListener('click', () => {
    const analytics = (el.querySelector('#c-analytics') as HTMLInputElement).checked;
    const marketing = (el.querySelector('#c-marketing') as HTMLInputElement).checked;
    void finish(analytics, marketing);
  });
}
